import { ReactComponent as BottomCardIMG } from '../../Icons/bottom-cart.svg';
import ClickOutSideDiv from './ClickOutSideDiv';
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import ProductCard from '../homeProduct/ProductCard';
import { useTranslation } from 'react-i18next';
import { currencyOptions } from '../../staticData/options';
import { useHistory } from 'react-router-dom';
import localRequest from '../../../src/services/LocalServer/localRequest';
import PromoModal from './PromoModal';
import Swal from 'sweetalert2';
import PingPad from '../items/Pingpad';
import request from '../../services/Request';
import KeyBoard from '../items/keyboard';
import logger from '../../services/LocalServer/logger';
import { applyPointsDiscountToItems } from '../../services/methods';

function BottomCard(props) {
  const cash_pay = localStorage.getItem('CASH_PAY') === 'TRUE';
  const history = useHistory();
  const {
    cart,
    setShowCart,
    showCart,
    langs,
    remove,
    isLocal,
    changePrice,
    promoRef,
    audio,
    stopPlay,
    clientUser,
    setClientUser,
    HFuser,
    cleanUp,
  } = props;
  const { t } = useTranslation();
  const machineData = JSON.parse(localStorage.getItem('machine'));

  const machineID = machineData._id;
  const tax = machineData.tax;
  const tax_rate = machineData.tax_rate;
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  const testMode = localStorage.getItem('testMode');
  symbol = symbol ? symbol : '$';
  let promoData = [];
  let prods = [];
  try {
    prods = JSON.parse(localStorage.getItem('products'));
    promoData = JSON.parse(localStorage.getItem('promo'));
  } catch (e) {}

  const [mainL, setMainL] = useState('en-US');
  const [products, setProducts] = useState(<div></div>);

  const [showPromo, setShowPromo] = useState(false);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);

  const [nowsubtotal, setSubtotal] = useState(0);
  const [nowdiscount, setDiscount] = useState(0);
  const [totalPrice, setTotal] = useState(0);
  const [finalTax, setTax] = useState(0);
  const [showPingPad, setShowPingPad] = useState(false);

  let cartStyle = () => {
    let text = 'Your Cart';
    if (machineData?.themeColor?.addToCartStyle === '1') {
      text = 'Your Bag';
    }
    return text;
  };

  useEffect(() => {
    let discount = cart.reduce((totalCost, item) => {
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          return totalCost;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              return (
                totalCost +
                parseFloat(
                  (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                )
              );
            } else {
              return (
                totalCost +
                parseFloat((item.discount * Math.trunc(item.quantity / item.buyX)).toFixed(2))
              );
            }
          } else {
            if (item.quantity < item.buyX) return totalCost;
            else {
              if (item.percentage == true) {
                return (
                  totalCost +
                  parseFloat(
                    (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                  )
                );
              } else {
                return (
                  totalCost +
                  parseFloat((item.discount * Math.trunc(item.quantity / item.buyX)).toFixed(2))
                );
              }
            }
          }
        } else return totalCost;
      } else if (item.buyX === 1) {
        if (item.discount != 0)
          return totalCost + parseFloat((item.price - item.discountedPrice).toFixed(2));
        else return totalCost;
      } else {
        if (item.discount > 0) {
          return (
            totalCost + parseFloat(((item.price - item.discountedPrice) * item.quantity).toFixed(2))
          );
        } else {
          return totalCost;
        }
      }
    }, 0);

    // const subtotal = cart.reduce((totalCost, item) => {
    //   return (totalCost += parseFloat((item.price * item.quantity).toFixed(2)));
    // }, 0);

    // setSubtotal(subtotal);
    const subtotal = cart.reduce((totalCost, item) => {
      let result = 0;
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          result = item.price;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.price * item.quantity * item.discount).toFixed(2));
            } else {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.discount * item.pQuantity).toFixed(2));
            }
          } else {
            if (item.quantity < item.buyX) {
              result = parseFloat((item.price * item.quantity).toFixed(2));
            } else {
              if (item.percentage == true) {
                result =
                  parseFloat((item.price * item.quantity).toFixed(2)) -
                  parseFloat((item.price * item.quantity * item.discount).toFixed(2));
              } else {
                result = parseFloat(
                  (
                    item.price * item.buyX * item.pQuantity -
                    item.discount +
                    item.price * (item.quantity - item.buyX * item.pQuantity)
                  ).toFixed(2)
                );
              }
            }
          }
        }
      } else if (item.buyX === 1) {
        result = parseFloat((item.discountedPrice + item.price * (item.quantity - 1)).toFixed(2));
      } else {
        result = parseFloat((item.discountedPrice * item.quantity).toFixed(2));
      }

      // apply tax
      if (!tax && typeof tax_rate?.typeA === 'number') {
        // console.log('result', result);
        // console.log('tax_rate', tax_rate);
        if (item.tax_type === '1') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeB) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '2') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeC) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '3') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeD) / item.quantity / 100).toFixed(2)
          );
          // typeA is the default tax rate
        } else {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeA) / item.quantity / 100).toFixed(2)
          );
        }
      } else {
        // console.log('tax');
        item.tax = parseFloat(((parseFloat(result) * tax) / item.quantity / 100).toFixed(2));
      }
      return totalCost + result;
    }, 0);

    setSubtotal(subtotal);

    // console.log('cart12', cart);

    let finalTax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);

    setTax(finalTax);

    let snewubtotal = parseFloat(subtotal.toFixed(2));
    let total = snewubtotal + finalTax;
    total = parseFloat(total.toFixed(2));

    if (clientUser?.discount?.amount > 0) {
      console.log('innnnnnnnnnnnnnnnn');
      discount = discount += clientUser?.discount?.amount;
      total = total - clientUser?.discount?.amount;
    }

    setDiscount(discount);

    setTotal(total);
  }, [cart, clientUser]);

  useEffect(() => {
    if (showPromo) {
      promoRef.current = true;
    } else {
      promoRef.current = false;
    }
  }, [showPromo]);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    } else if (mycoockie === 'zh') {
      setMainL('zh-CN');
    }
  }, []);

  useEffect(() => {
    setClientUser({ ...clientUser, discount: null, discount_id: null });
    // console.log(cart);1
    if (cart.length === 0) {
      setShowCart(false);
    }
  }, [cart]);

  useEffect(() => {
    console.log('cart', cart);
    console.log('prods', prods);
  }, [showCart]);

  // const calculateitemPrice = (item) => {
  //   return (
  //     <span>
  //       {mainL != 'fr-CA' && symbol}
  //       {parseFloat((item.price * item.quantity).toFixed(2)).toLocaleString(mainL, currencyOptions)}11
  //       {mainL == 'fr-CA' && symbol}
  //     </span>
  //   );
  // };

  const confirmPointRedemption = async (pointCanUse, totalPrice) => {
    try {
      const result = await Swal.fire({
        title: 'Redeem Points',
        text: `Redeem ${pointCanUse} points for $${(pointCanUse / 100).toFixed(2)}?`,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        const discountedPrice = (totalPrice - pointCanUse / 100).toFixed(2);
        setTotal(parseFloat(discountedPrice));
        localStorage.setItem('TotalPrice', discountedPrice);
        clientUser.points_used = Math.floor(pointCanUse);
        clientUser.points_gained = Math.floor(
          discountedPrice * machineData?.mobileSetting?.pg_point
        );
        if (machineData?.mobileSetting?.pg_radio == '1') {
          clientUser.points_gained = Math.floor(machineData?.mobileSetting?.pg_point || 0);
        }
        setClientUser({ ...clientUser });
        return { success: true, newTotal: parseFloat(discountedPrice) };
      }

      return { success: false, newTotal: totalPrice };
    } catch (error) {
      console.error('Point redemption error:', error);
      return { success: false, newTotal: totalPrice };
    }
  };

  // Function to handle ping submission from PingPad
  const handlePingSubmit = (pingValue) => {
    console.log('Ping value entered:', pingValue);
    setShowPingPad(false);

    // Make the login request with the ping value
    request({
      method: 'POST',
      url: '/loginClientUser/machineLogin',
      data: {
        referTo: machineData?.belongTo,
        pin: pingValue,
      },
      timeout: 4000,
    })
      .then(async (res) => {
        Swal.fire({
          icon: 'success',
          title: `Welcome back ${res.data.username}!`,
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 3000,
        });

        setClientUser(res.data);
        // Continue with the rest of the checkout process
        continueCheckout();
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Login failed',
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 2000,
        });
        console.log('error', err);
      });
  };

  const checkout = async () => {
    // Check if ping is required for login
    console.log('mobilesetting', machineData?.mobileSetting);
    if (machineData?.mobileSetting?.login_type_radio == '1') {
      // Show PingPad instead of making direct request
      setShowPingPad(true);
      return;
    }

    // Continue with normal checkout if no ping required
    continueCheckout();
  };

  const continueCheckout = async () => {
    //check access limit
    console.log('cart', cart);
    // const categories = JSON.parse(localStorage.getItem('category'));
    // if (categories) {
    //   function getCategoryTotalsWithLimitExceeded(categoryArray, cartArray) {
    //     // Create a map to store category totals
    //     const categoryTotalsMap = new Map();
    //     let limitExceeded = false;

    //     // Calculate category totals
    //     cartArray.forEach((cartItem) => {
    //       if (
    //         cartItem.category &&
    //         Array.isArray(cartItem.category) &&
    //         cartItem.category.length > 0
    //       ) {
    //         cartItem.category.forEach((categoryId) => {
    //           const categoryTotal = categoryTotalsMap.get(categoryId) || 0;
    //           categoryTotalsMap.set(categoryId, categoryTotal + cartItem.quantity);

    //           // Check for limit exceededw
    //           const category = categoryArray.find((category) => category._id === categoryId);
    //           if (
    //             category &&
    //             category.limit !== undefined &&
    //             categoryTotal + cartItem.quantity > category.limit
    //           ) {
    //             limitExceeded = true;
    //           }
    //         });
    //       }
    //     });

    //     // Create an object with category totals and check for limit exceeded
    //     const categoryTotals = {};

    //     categoryTotalsMap.forEach((total, categoryId) => {
    //       const category = categoryArray.find((category) => category._id === categoryId);
    //       if (category) {
    //         categoryTotals[categoryId] = {
    //           name: category.name.en,
    //           total: total,
    //           limit: category.limit,
    //         };
    //       }
    //     });

    //     return { categoryTotals, limitExceeded };
    //   }

    //   try {
    //     const { limitExceeded } = getCategoryTotalsWithLimitExceeded(categories, cart);
    //     if (limitExceeded) {
    //       return Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: 'You have exceeded the limit of one or more categories!',
    //       });
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     return logger(2, '[Error]| when checking limitExceeded' + e);
    //   }
    // }

    const FinalProducts = cart.reduce((acc, item) => {
      item.price = parseFloat(item.price.toFixed(2));
      // item.discountedPrice = parseFloat(item.discountedPrice.toFixed(2));
      if (item?.buyX === 1) {
        if (item.quantity > 1) {
          return acc.concat([
            {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              picture: item.image,
              category: item.category,
              prodType: item.prodType,
              referTo: item.referTo,
              product: item.id,
              upc: item.upc,
              title: item.title,
              promo: null,
              quantity: item.quantity - 1,
              discount: 0,
              soldPrice: parseFloat((item.price * (item.quantity - 1)).toFixed(2)),
              emailCode: item.emailCode,
              oneTime: item.oneTime,
              code: item.code,
              addition: item.addition,
              tax: item.tax,
              promoType: item.promoType,
              bundle_prod: item.bundle_prod,
            },
            {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              picture: item.image,
              category: item.category,
              prodType: item.prodType,
              product: item.id,
              referTo: item.referTo,
              upc: item.upc,
              title: item.title,
              promo: item.promo,
              quantity: 1,
              discount: item.percentage
                ? parseFloat((item.discount * item.price).toFixed(2))
                : item.discount,
              soldPrice: parseFloat(item.discountedPrice.toFixed(2)),
              emailCode: item.emailCode,
              oneTime: item.oneTime,
              code: item.code,
              addition: item.addition,
              tax: item.tax,
              promoType: item.promoType,
              bundle_prod: item.bundle_prod,
            },
          ]);
        } else if (item.quantity == 1) {
          return acc.concat([
            {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              picture: item.image,
              category: item.category,
              prodType: item.prodType,
              referTo: item.referTo,
              product: item.id,
              upc: item.upc,
              title: item.title,
              promo: item.promo,
              quantity: 1,
              discount: item.percentage
                ? parseFloat((item.discount * item.price).toFixed(2))
                : item.discount,
              soldPrice: parseFloat(item.discountedPrice.toFixed(2)),
              emailCode: item.emailCode,
              oneTime: item.oneTime,
              code: item.code,
              addition: item.addition,
              tax: item.tax,
              promoType: item.promoType,
              bundle_prod: item.bundle_prod,
            },
          ]);
        }
      } else if (item.buyX > 1) {
        if (item.quantity < item.buyX) {
          return acc.concat([
            {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              picture: item.image,
              category: item.category,
              prodType: item.prodType,
              referTo: item.referTo,
              product: item.id,
              upc: item.upc,
              title: item.title,
              promo: null,
              quantity: item.quantity,
              discount: 0,
              soldPrice: item.price * item.quantity,
              emailCode: item.emailCode,
              oneTime: item.oneTime,
              code: item.code,
              addition: item.addition,
              tax: item.tax,
              promoType: item.promoType,
              bundle_prod: item.bundle_prod,
            },
          ]);
        }
        if (item.quantity >= item.buyX) {
          if (item.pQuantity * item.buyX === item.quantity) {
            if (item.percentage) {
              return acc.concat([
                {
                  item_id: Math.floor(10000000 + Math.random() * 90000000),
                  picture: item.image,
                  category: item.category,
                  prodType: item.prodType,
                  referTo: item.referTo,
                  product: item.id,
                  upc: item.upc,
                  title: item.title,
                  promo: item.promo,
                  quantity: item.quantity,
                  discount: parseFloat((item.discount * item.price * item.quantity).toFixed(2)),
                  soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
                  emailCode: item.emailCode,
                  oneTime: item.oneTime,
                  code: item.code,
                  addition: item.addition,
                  tax: item.tax,
                  promoType: item.promoType,
                  bundle_prod: item.bundle_prod,
                },
              ]);
            } else {
              return acc.concat([
                {
                  item_id: Math.floor(10000000 + Math.random() * 90000000),
                  picture: item.image,
                  category: item.category,
                  prodType: item.prodType,
                  referTo: item.referTo,
                  product: item.id,
                  upc: item.upc,
                  title: item.title,
                  promo: item.promo,
                  quantity: item.quantity,
                  // discount: parseFloat((item.discount/item.buyX).toFixed(2)),
                  discount: item.discount * item.pQuantity,
                  soldPrice: parseFloat(
                    (item.price * item.quantity - item.discount * item.pQuantity).toFixed(2)
                  ),
                  emailCode: item.emailCode,
                  oneTime: item.oneTime,
                  code: item.code,
                  addition: item.addition,
                  tax: item.tax,
                  promoType: item.promoType,
                  bundle_prod: item.bundle_prod,
                },
              ]);
            }
          } else {
            if (item.percentage) {
              return acc.concat([
                {
                  item_id: Math.floor(10000000 + Math.random() * 90000000),
                  picture: item.image,
                  category: item.category,
                  prodType: item.prodType,
                  referTo: item.referTo,
                  product: item.id,
                  upc: item.upc,
                  title: item.title,
                  promo: item.promo,
                  quantity: item.quantity,
                  discount: parseFloat((item.discount * item.price * item.quantity).toFixed(2)),
                  soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
                  emailCode: item.emailCode,
                  oneTime: item.oneTime,
                  code: item.code,
                  addition: item.addition,
                  tax: item.tax,
                  promoType: item.promoType,
                  bundle_prod: item.bundle_prod,
                },
              ]);
            } else {
              return acc.concat([
                {
                  item_id: Math.floor(10000000 + Math.random() * 90000000),
                  picture: item.image,
                  category: item.category,
                  prodType: item.prodType,
                  referTo: item.referTo,
                  product: item.id,
                  upc: item.upc,
                  title: item.title,
                  promo: null,
                  quantity: item.quantity - item.pQuantity * item.buyX,
                  discount: 0,
                  soldPrice: item.price * (item.quantity - item.pQuantity * item.buyX),
                  emailCode: item.emailCode,
                  oneTime: item.oneTime,
                  code: item.code,
                  addition: item.addition,
                  tax: item.tax,
                  promoType: item.promoType,
                  bundle_prod: item.bundle_prod,
                },
                {
                  item_id: Math.floor(10000000 + Math.random() * 90000000),
                  picture: item.image,
                  category: item.category,
                  prodType: item.prodType,
                  referTo: item.referTo,
                  product: item.id,
                  upc: item.upc,
                  title: item.title,
                  promo: item.promo,
                  quantity: item.pQuantity * item.buyX,
                  discount: item.discount * item.pQuantity,
                  soldPrice: parseFloat(
                    (item.price * item.quantity - item.discount * item.pQuantity).toFixed(2)
                  ),
                  emailCode: item.emailCode,
                  oneTime: item.oneTime,
                  code: item.code,
                  addition: item.addition,
                  tax: item.tax,
                  promoType: item.promoType,
                  bundle_prod: item.bundle_prod,
                },
              ]);
            }
          }
        }
      } else {
        return acc.concat([
          {
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            picture: item.image,
            category: item.category,
            prodType: item.prodType,
            referTo: item.referTo,
            product: item.id,
            upc: item.upc,
            title: item.title,
            promo: item.promo,
            quantity: item.quantity,
            discount: item.percentage
              ? parseFloat((item.discount * item.price * item.quantity).toFixed(2))
              : item.discount * item.quantity,
            soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
            emailCode: item.emailCode,
            oneTime: item.oneTime,
            code: item.code,
            addition: item.addition,
            tax: item.tax,
            promoType: item.promoType,
            bundle_prod: item.bundle_prod,
          },
        ]);
      }
    }, []);

    if (cart && cart.length > 0) {
      //calcuate checkout points use
      const mobileSetting = machineData?.mobileSetting;
      console.log('clientUser', clientUser);
      console.log('machineSetting', machineData);
      console.log('totalPrice', totalPrice);

      localStorage.setItem('FinalProducts', JSON.stringify(FinalProducts));
      localStorage.setItem('TotalPrice', JSON.stringify(totalPrice));
      localStorage.setItem('FinalTax', JSON.stringify(finalTax));
      //client logged in
      let finalTotalPrice = totalPrice;
      let pointDiscountAmount = 0;
      if (clientUser?._id) {
        const pointsSetting = () => {
          clientUser.points_used = 0;
          clientUser.points_gained = Math.floor(finalTotalPrice);
          if (machineData?.mobileSetting?.pg_radio == '1') {
            clientUser.points_gained = Math.floor(machineData?.mobileSetting?.pg_point || 0);
          }
          setClientUser({ ...clientUser });
        };

        if (clientUser?.points > mobileSetting?.minimum_points) {
          //maxium points can be used
          const maxTotalPoints = finalTotalPrice * 100;
          const pointCanUse =
            clientUser?.points > maxTotalPoints ? maxTotalPoints : clientUser?.points;

          const result = await confirmPointRedemption(pointCanUse, finalTotalPrice);
          if (!result.success) {
            pointsSetting();
          } else {
            finalTotalPrice = result.newTotal;
            pointDiscountAmount = parseFloat((totalPrice - result.newTotal).toFixed(2));
          }
        } else {
          pointsSetting();
        }
      }
      let items = [];

      if (FinalProducts?.length > 0 && FinalProducts[0]?.bundle_prod?.length > 0) {
        //format item price
        let totalOldPrice = 0;
        FinalProducts[0]?.bundle_prod?.forEach((pd, index) => {
          let idx = prods.findIndex((e) => e._id === pd._id);
          if (idx > -1) {
            totalOldPrice += prods[idx].price * pd.quantity;
            pd.price = prods[idx].price;
            pd.product = prods[idx];
          } else {
            error = true;
            return;
          }
        });

        // FinalProducts[0]?.bundle_prod?.forEach((bundle_item) => {

        //   bundle_item.newPrice = parseFloat(
        //     (FinalProducts[0].soldPrice * bundle_item.itemPercentage).toFixed(2)
        //   );
        //   bundle_item.tax = parseFloat(
        //     (FinalProducts[0].tax * bundle_item.itemPercentage).toFixed(2)
        //   );
        // });

        //find product
        let error = false;
        FinalProducts[0]?.bundle_prod?.forEach((pd, index) => {
          for (let i = 0; i < pd.quantity; i++) {
            pd.itemPercentage = pd.price / totalOldPrice;
            pd.newPrice = parseFloat((FinalProducts[0].soldPrice * pd.itemPercentage).toFixed(2));
            pd.tax = parseFloat((FinalProducts[0].tax * pd.itemPercentage).toFixed(2));
            let product = pd.product;
            const FprodName =
              product.name[langs] && product.name[langs] !== ''
                ? product.name[langs]
                : product.name?.en;
            // console.log('index', i);
            const newObject = {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              product_name: FprodName,
              category: product.category,
              upc: product.upc,
              quantity: 1,
              soldPrice: pd.newPrice,
              tax_amount: pd.tax,
              prodType: product.prodType,
              referTo: product.referTo,
              product: product._id,
              discount: 0,
              picture: product.productPictures[0],
              total_amount: pd.newPrice + pd.tax,
              virtual: product.prodType !== 'prod' ? true : false,
            };
            items.push(newObject);
          }
        });
        if (error) {
          Swal.Fire({
            icon: 'error',
            title: 'Error',
            text: 'Product not found',
          });
          return;
        } else {
          FinalProducts[0].itemSold = items;
        }
      } else {
        items = FinalProducts.reduce((acc, product) => {
          console.log('productproductproductproduct', product);
          const tax_amount = product.tax;
          const array = [];
          for (let i = 0; i < product.quantity; i++) {
            const FprodName =
              product.title[langs] && product.title[langs] !== ''
                ? product.title[langs]
                : product.title?.en;
            const newObject = {
              item_id: Math.floor(10000000 + Math.random() * 90000000),
              product_name: FprodName,
              category: product.category,
              upc: product.upc,
              quantity: 1,
              soldPrice: product.soldPrice / product.quantity,
              tax_amount: tax_amount,
              prodType: product.prodType,
              referTo: product.referTo,
              product: product.product,
              emailCode: product.emailCode,
              oneTime: product.oneTime,
              codeEntered: product.code,
              discount: product.discount / product.quantity,
              promo: product.promo,
              promoType: product.promoType,
              picture: product.picture,
              virtual: product.prodType !== 'prod' ? true : false,
              total_amount: parseFloat(
                (product.soldPrice / product.quantity + tax_amount).toFixed(2)
              ),
            };
            if (localStorage.getItem('TW_SPAIN') === 'TRUE') {
              newObject.id_familia = product.addition?.id_familia;
              newObject.id_subfamilia = product.addition?.id_subfamilia;
              newObject.subconcepto = product.addition?.subconcepto;
              newObject.VAT_percentile = machineData?.tax ? machineData?.tax : tax_rate.typeA;
            }
            array.push(newObject);
          }
          return acc.concat(array);
        }, []);
      }

      console.log('items', items);

      localStorage.setItem('FinalProducts', JSON.stringify(FinalProducts));
      localStorage.setItem('SeparateItem', JSON.stringify(items));

      let order_info = {
        order_id: Math.floor(10000000 + Math.random() * 90000000),
        item_amount: items.length,
        tax_amount: finalTax,
        total_amount: finalTotalPrice,
        items: items,
        payment_type: 'CC',
      };

      localStorage.setItem('order_info', JSON.stringify(order_info));

      console.log('pointDiscountAmount', pointDiscountAmount);
      if (pointDiscountAmount > 0) {
        console.log('pointDiscountAmount', pointDiscountAmount);
        applyPointsDiscountToItems(order_info, pointDiscountAmount);
      }

      if (audio?.checkout) {
        stopPlay();
        audio.checkout.play();
      }

      if (testMode === 'false') {
        if (cash_pay) {
          history.push(`/machineUI/selectPayment/${machineID}`);
        } else {
          if (
            localStorage.getItem('PAYMENT_METHOD') !== 'WEVEND' &&
            localStorage.getItem('PAYMENT_METHOD') !== 'ISVPAY'
          ) {
            await localRequest({
              method: 'post',
              url: '/updateKioskStatus',
              data: {
                status: 'OrderCreated',
                order_info: order_info,
              },
            }).then((res) => {
              history.push(`/machineUI/payment/${machineID}`);
            });
          } else {
            history.push(`/machineUI/payment/${machineID}`);
          }
        }
        // history.push(`/machineUI/product-dispense/${machineID}`);
      } else {
        history.push(`/machineUI/product-dispense/${machineID}`);
      }
    }
  };

  function getSubTotal(cart) {
    return nowsubtotal.toLocaleString(mainL, currencyOptions);
  }

  function getDiscountTotal(cart) {
    return nowdiscount.toLocaleString(mainL, currencyOptions);
  }

  function getTotal(cart) {
    return totalPrice.toLocaleString(mainL, currencyOptions);
  }

  function getFinalTax(cart) {
    return finalTax.toLocaleString(mainL, currencyOptions);
  }

  function promoCode() {
    setShowPromo(true);
  }

  useEffect(() => {
    let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
    symbol = symbol ? symbol : '$';

    const prods = cart.map((prod, i) => {
      // console.log(prod);
      // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;
      let url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.image}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;

      if (prod.prodType === 'fridge1' || prod.prodType === 'fridge2') {
        url = isLocal
          ? `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/${prod.image}`
          : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;
      }
      prod.name = prod.title;
      return (
        <ProductCard
          remove={remove}
          langs={langs}
          mainL={mainL}
          symbol={symbol}
          cart={props.cart}
          alterquantity={props.alterquantity}
          add={props.add}
          decreStock={props.decreStock}
          prod={prod}
          image={url}
          key={i}
          isCart={true}
          twoLine={true}
        />
      );
    });
    setProducts(prods);
  }, [cart]);

  if (showCart) {
    return (
      <ClickOutSideDiv setShowCart={setShowCart} showPromo={showPromo}>
        <PingPad
          show={showPingPad}
          setShow={setShowPingPad}
          run={handlePingSubmit}
          center={true}
          optionText={'Enter your PIN to checkout'}
          close={() => setShowPingPad(false)}
        />
        {promoData?.length > 0 && (
          <PromoModal
            setClientUser={setClientUser}
            clientUser={clientUser}
            products={prods}
            changePrice={changePrice}
            cart={cart}
            total={totalPrice}
            show={showPromo}
            setShow={setShowPromo}
            onHide={() => {
              setShowPromo(false);
            }}
          />
        )}

        <div className="shopping-cart">
          <div className="shopping-cart-left">
            <div className="cart-title-div">
              <div className="cart-title"> {t(cartStyle())}</div>
            </div>

            <div className="cart-home-products">{products}</div>
          </div>
          <div className="shopping-cart-right">
            <div className="shopping-cart-button-div">
              {cart && cart.length > 0 && (
                <div
                  id="check-out-button"
                  className="view-more-button cart-checkout-button"
                  onClick={checkout}
                >
                  {t(`CHECKOUT`)}
                </div>
              )}
              {promoData?.length > 0 && (
                <div className="view-more-button cart-checkout-button" onClick={promoCode}>
                  {t(`PROMO CODE`)}
                </div>
              )}
              <div
                className="view-more-button cart-checkout-button"
                onClick={() => {
                  cleanUp();
                }}
              >
                {machineData?.themeColor?.addToCartStyle === '1' ? `EMPTY CART` : t(`EMPTY CART`)}
              </div>
            </div>

            {/* <div className="promo-code cart-total-text">Promo Code </div> */}
            {/* <div className="cart-total-text cart-subtotal" style={{ marginTop: '188px' }}> */}
            <div className="cart-total-text cart-subtotal" style={{ marginTop: '50px' }}>
              <p>
                <span className="cart-left-text">{t(`Sub total`)}: </span>
                <span className="cart-right-text">
                  {mainL != 'fr-CA' && symbol}
                  {getSubTotal()}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
            {nowdiscount !== 0 && (
              <div className="cart-total-text">
                <p>
                  <span className="cart-left-text">{t(`Discount`)}: </span>
                  <span className="cart-right-text">
                    {mainL != 'fr-CA' && symbol}
                    {getDiscountTotal()}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
            )}

            <div className="cart-total-text">
              <p>
                <span className="cart-left-text">{t('Tax')}: </span>
                <span className="cart-right-text">
                  {mainL != 'fr-CA' && symbol}
                  {getFinalTax()}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
            <div className="cart-totalfinal-text">
              <p>
                <span className="cart-left-text">{t(`Total`)}:</span>
                <span className="cart-right-text">
                  {mainL != 'fr-CA' && symbol}
                  {getTotal()}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
          </div>
        </div>
      </ClickOutSideDiv>
    );
  } else {
    return (
      cart.length > 0 && (
        <div
          className="green-cart-bottom"
          onClick={() => {
            setShowCart(true);
          }}
        >
          <BottomCardIMG className="bottomcartIMG" />
          <span className="cart-item-count">
            {cart.reduce((total, item) => total + item.quantity, 0)}
          </span>
        </div>
      )
    );
  }
}
export default BottomCard;
